//Drop Pkm - 2025 Pinball
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('nav ul li a').forEach(function (link) {
        if (link.textContent.trim() === 'Drop') {
            var span = document.createElement('span');
            span.className = 'pkm';
            link.appendChild(span);
        }
    });
});

//Collection Summer - 2025
document.addEventListener('DOMContentLoaded', function () {
    const targetText = 'Summer Collection';

    document.querySelectorAll('nav ul li a').forEach(function (link) {
        const cleanText = link.textContent.trim().replace(/\s+/g, '').toUpperCase();
        const cleanTarget = targetText.replace(/\s+/g, '').toUpperCase();

        if (cleanText === cleanTarget && !link.dataset.animated) {
            link.dataset.animated = 'true';
            link.textContent = '';

            const chars = targetText.split('');
            const spans = [];

            chars.forEach((char, i) => {
                const span = document.createElement('span');

                if (char === ' ') {
                    span.innerHTML = '&nbsp;';
                    span.style.display = 'inline-block';
                    span.style.width = '0.5em';
                } else {
                    span.textContent = char;
                    span.style.display = 'inline-block';
                    span.style.transition = `
                        transform 0.4s cubic-bezier(.68,-0.55,.27,1.55),
                        color 0.4s ease-in-out
                    `;
                    span.style.color = 'inherit';
                }

                link.appendChild(span);
                spans.push(span);
            });

            function waveAnimation() {
                spans.forEach((span, i) => {
                    if (span.textContent.trim() !== '') {
                        setTimeout(() => {
                            // Monte avec couleur #FFBF47
                            span.style.transform = 'translateY(-6px)';
                            span.style.color = '#FFBF47';
                            setTimeout(() => {
                                // Redescend avec couleur #329FFE
                                span.style.transform = 'translateY(0)';
                                span.style.color = '#329FFE';
                                setTimeout(() => {
                                    // Retour à la couleur d'origine (héritée)
                                    span.style.color = '';
                                }, 300);
                            }, 400);
                        }, i * 60);
                    }
                });
            }

            const totalDuration = (spans.length - 1) * 60 + 400;

            setTimeout(function loop() {
                waveAnimation();
                setTimeout(loop, totalDuration + 3000);
            }, 500);
        }
    });
});

//Collection Summer - 2025
// document.addEventListener('DOMContentLoaded', function () {
//     const targetText = 'Summer Collection';

//     document.querySelectorAll('nav ul li a').forEach(function (link) {
//         const cleanText = link.textContent.trim().replace(/\s+/g, '').toUpperCase();
//         const cleanTarget = targetText.replace(/\s+/g, '').toUpperCase();

//         if (cleanText === cleanTarget && !link.dataset.animated) {
//             link.dataset.animated = 'true';
//             link.textContent = '';

//             const chars = targetText.split('');
//             const spans = [];

//             chars.forEach((char, i) => {
//                 const span = document.createElement('span');

//                 if (char === ' ') {
//                     span.innerHTML = '&nbsp;';
//                     span.style.display = 'inline-block';
//                     span.style.width = '0.5em';
//                 } else {
//                     span.textContent = char;
//                     span.style.display = 'inline-block';
//                     span.style.transition = `
//                         transform 0.4s cubic-bezier(.68,-0.55,.27,1.55),
//                         color 0.4s ease-in-out
//                     `;
//                     span.style.color = 'inherit';
//                 }

//                 link.appendChild(span);
//                 spans.push(span);
//             });

//             function waveAnimation() {
//                 spans.forEach((span, i) => {
//                     if (span.textContent.trim() !== '') {
//                         setTimeout(() => {
//                             // Monte avec couleur #FFBF47
//                             span.style.transform = 'translateY(-6px)';
//                             span.style.color = '#FFBF47';
//                             setTimeout(() => {
//                                 // Redescend avec couleur #329FFE
//                                 span.style.transform = 'translateY(0)';
//                                 span.style.color = '#329FFE';
//                                 setTimeout(() => {
//                                     // Retour à la couleur d'origine (héritée)
//                                     span.style.color = '';
//                                 }, 300);
//                             }, 400);
//                         }, i * 60);
//                     }
//                 });
//             }

//             const totalDuration = (spans.length - 1) * 60 + 400;

//             setTimeout(function loop() {
//                 waveAnimation();
//                 setTimeout(loop, totalDuration + 3000);
//             }, 500);
//         }
//     });
// });

//Collection MAGIC BOGOSS
// document.addEventListener('DOMContentLoaded', function () {
//     const targetText = 'MAGIC BEAU GOSSE';

//     document.querySelectorAll('nav ul li a').forEach(function (link) {
//         const cleanText = link.textContent.trim().replace(/\s+/g, '').toUpperCase();
//         const cleanTarget = targetText.replace(/\s+/g, '').toUpperCase();

//         if (cleanText === cleanTarget && !link.dataset.animated) {
//             link.dataset.animated = 'true';
//             link.textContent = '';

//             const chars = targetText.split('');
//             const spans = [];

//             chars.forEach((char, i) => {
//                 const span = document.createElement('span');

//                 if (char === ' ') {
//                     span.innerHTML = '&nbsp;';
//                     span.style.display = 'inline-block';
//                     span.style.width = '0.2em';
//                 } else {
//                     span.textContent = char;
//                     span.style.display = 'inline-block';
//                     span.style.transition = `
//                         transform 0.4s cubic-bezier(.68,-0.55,.27,1.55),
//                         color 0.4s ease-in-out
//                     `;
//                     span.style.color = 'inherit';
//                 }

//                 link.appendChild(span);
//                 spans.push(span);
//             });

//             function waveAnimation() {
//                 spans.forEach((span, i) => {
//                     if (span.textContent.trim() !== '') {
//                         setTimeout(() => {
//                             span.style.color = '#f5d469';
//                             setTimeout(() => {
//                                 span.style.color = '#623166';
//                                 setTimeout(() => {
//                                     // Retour à la couleur d'origine (héritée)
//                                     span.style.transform = 'translateY(0px)';
//                                     span.style.color = '';
//                                 }, 300);
//                             }, 400);
//                         }, i * 60);
//                     }
//                 });
//             }

//             const totalDuration = (spans.length - 1) * 60 + 400;

//             setTimeout(function loop() {
//                 waveAnimation();
//                 setTimeout(loop, totalDuration + 3000);
//             }, 500);
//         }
//     });
// });

//Gachapoints product link - Shimmer doré
document.addEventListener('DOMContentLoaded', function () {
    const gachaLink = document.querySelector('.gachapoints__link');
    if (gachaLink && !gachaLink.dataset.animated) {
        gachaLink.dataset.animated = 'true';
        const text = gachaLink.textContent;
        gachaLink.textContent = '';

        const spans = [];
        text.split('').forEach((char) => {
            const span = document.createElement('span');
            if (char === ' ') {
                span.innerHTML = '&nbsp;';
                span.style.display = 'inline-block';
                span.style.width = '0.3em';
            } else {
                span.textContent = char;
                span.style.display = 'inline-block';
                span.style.transition = 'color 0.3s ease, opacity 0.3s ease';
                span.style.color = '#FF5F00';
            }
            gachaLink.appendChild(span);
            spans.push(span);
        });

        function shimmerGacha() {
            spans.forEach((span, i) => {
                if (span.textContent.trim() !== '') {
                    setTimeout(() => {
                        span.style.color = '#c9a84c';
                        span.style.opacity = '0.85';
                        setTimeout(() => {
                            span.style.color = '#FF5F00';
                            span.style.opacity = '1';
                        }, 250);
                    }, i * 50);
                }
            });
        }

        const totalDuration = (spans.length - 1) * 50 + 250;
        setTimeout(function loop() {
            shimmerGacha();
            setTimeout(loop, totalDuration + 5000);
        }, 1000);
    }
});

//Paiheme Club - Shimmer doré
document.addEventListener('DOMContentLoaded', function () {
    const targetText = 'Paiheme Club';

    document.querySelectorAll('nav ul li a').forEach(function (link) {
        const cleanText = link.textContent.trim().replace(/\s+/g, '').toUpperCase();
        const cleanTarget = targetText.replace(/\s+/g, '').toUpperCase();

        if (cleanText === cleanTarget && !link.dataset.animated) {
            link.dataset.animated = 'true';
            link.textContent = '';

            const chars = targetText.split('');
            const spans = [];

            chars.forEach((char, i) => {
                const span = document.createElement('span');

                if (char === ' ') {
                    span.innerHTML = '&nbsp;';
                    span.style.display = 'inline-block';
                    span.style.width = '0.3em';
                } else {
                    span.textContent = char;
                    span.style.display = 'inline-block';
                    span.style.transition = 'color 0.3s ease, opacity 0.3s ease';
                    span.style.color = '#FF5F00';
                }

                link.appendChild(span);
                spans.push(span);
            });

            function shimmerAnimation() {
                spans.forEach((span, i) => {
                    if (span.textContent.trim() !== '') {
                        setTimeout(() => {
                            span.style.color = '#c9a84c';
                            span.style.opacity = '0.85';
                            setTimeout(() => {
                                span.style.color = '#FF5F00';
                                span.style.opacity = '1';
                            }, 250);
                        }, i * 50);
                    }
                });
            }

            const totalDuration = (spans.length - 1) * 50 + 250;

            setTimeout(function loop() {
                shimmerAnimation();
                setTimeout(loop, totalDuration + 5000);
            }, 1000);
        }
    });
});

//Carnet de coloriages
document.addEventListener('DOMContentLoaded', function () {
    const targetText = 'Carnet de coloriages';

    document.querySelectorAll('nav ul li a').forEach(function (link) {
        const cleanText = link.textContent.trim().replace(/\s+/g, '').toUpperCase();
        const cleanTarget = targetText.replace(/\s+/g, '').toUpperCase();

        if (cleanText === cleanTarget && !link.dataset.animated) {
            link.dataset.animated = 'true';
            link.textContent = '';

            const chars = targetText.split('');
            const spans = [];

            chars.forEach((char, i) => {
                const span = document.createElement('span');

                if (char === ' ') {
                    span.innerHTML = '&nbsp;';
                    span.style.display = 'inline-block';
                    span.style.width = '0.5em';
                } else {
                    span.textContent = char;
                    span.style.display = 'inline-block';
                    span.style.transition = `
                        transform 0.2s cubic-bezier(.68,-0.55,.27,1.55),
                        color 0.2s ease-in-out
                    `;
                    span.style.color = 'inherit';
                }

                link.appendChild(span);
                spans.push(span);
            });

            function waveAnimation() {
                spans.forEach((span, i) => {
                    if (span.textContent.trim() !== '') {
                        setTimeout(() => {
                            span.style.transform = 'translateY(-6px) rotate(15deg)';
                            span.style.color = '#ff2b32ff';
                            setTimeout(() => {
                                span.style.transform = 'translateY(0px) rotate(-0deg)';
                                span.style.color = '#231d49';
                                setTimeout(() => {
                                    span.style.color = '';
                                }, 300);
                            }, 400);
                        }, i * 60);
                    }
                });
            }

            const totalDuration = (spans.length - 1) * 60 + 400;

            setTimeout(function loop() {
                waveAnimation();
                setTimeout(loop, totalDuration + 3000);
            }, 500);
        }
    });
});



//30th Anniversary - Pop + étincelle
document.addEventListener('DOMContentLoaded', function () {
    const targetText = '30th Anniversary';

    document.querySelectorAll('nav ul li a').forEach(function (link) {
        const cleanText = link.textContent.trim().replace(/\s+/g, '').toUpperCase();
        const cleanTarget = targetText.replace(/\s+/g, '').toUpperCase();

        if (cleanText === cleanTarget && !link.dataset.animated) {
            link.dataset.animated = 'true';
            const label = link.textContent.trim();
            link.textContent = '';
            if (getComputedStyle(link).position === 'static') link.style.position = 'relative';

            const chars = label.split('');
            const spans = [];

            chars.forEach((char) => {
                const span = document.createElement('span');

                if (char === ' ') {
                    span.innerHTML = '&nbsp;';
                    span.style.display = 'inline-block';
                    span.style.width = '0.3em';
                } else {
                    span.textContent = char;
                    span.style.display = 'inline-block';
                    span.style.transition = `
                        transform 0.25s cubic-bezier(.68,-0.55,.27,1.55),
                        color 0.25s ease-in-out
                    `;
                    span.style.color = 'inherit';
                }

                link.appendChild(span);
                spans.push(span);
            });

            // Étincelle qui éclate en fin de mot
            const sparkle = document.createElement('span');
            sparkle.textContent = '✦';
            sparkle.setAttribute('aria-hidden', 'true');
            sparkle.style.position = 'absolute';
            sparkle.style.top = '-0.4em';
            sparkle.style.right = '-0.7em';
            sparkle.style.fontSize = '0.7em';
            sparkle.style.color = '#c9a84c';
            sparkle.style.pointerEvents = 'none';
            sparkle.style.opacity = '0';
            sparkle.style.transform = 'scale(0) rotate(0deg)';
            sparkle.style.transition = 'transform 0.4s cubic-bezier(.68,-0.55,.27,1.55), opacity 0.4s ease';
            link.appendChild(sparkle);

            function popAnimation() {
                spans.forEach((span, i) => {
                    if (span.textContent.trim() !== '') {
                        setTimeout(() => {
                            // Zoom avec couleur #c83d35
                            span.style.transform = 'scale(1.35)';
                            span.style.color = '#c83d35';
                            setTimeout(() => {
                                span.style.transform = 'scale(1)';
                                setTimeout(() => {
                                    span.style.color = '';
                                }, 400);
                            }, 250);
                        }, i * 45);
                    }
                });

                setTimeout(() => {
                    sparkle.style.opacity = '1';
                    sparkle.style.transform = 'scale(1.2) rotate(180deg)';
                    setTimeout(() => {
                        sparkle.style.opacity = '0';
                        sparkle.style.transform = 'scale(0) rotate(360deg)';
                    }, 600);
                }, spans.length * 45);
            }

            const totalDuration = spans.length * 45 + 1000;

            setTimeout(function loop() {
                popAnimation();
                setTimeout(loop, totalDuration + 3000);
            }, 800);
        }
    });
});
